import React from 'react';
import ReactDOM from 'react-dom/client';
import { FluentProvider } from '@fluentui/react-components';
import App from './App';
import { useTheme } from './hooks/useTheme';

function Root() {
  const { theme } = useTheme();
  return (
    <React.StrictMode>
      <FluentProvider theme={theme}>
        <App />
      </FluentProvider>
    </React.StrictMode>
  );
}

const render = () => {
  ReactDOM.createRoot(document.getElementById('root')!).render(<Root />);
};

if (typeof Office !== 'undefined' && Office.onReady) {
  Office.onReady(() => render());
} else {
  render();
}
